module.exports = __webpack_public_path__ + "static/pachinko-2d76b6b6d10f8ec6755a071099f545ef.jpg";